import { useRoute } from "../lib/router.tsx";
import { metaPour } from "../app/config.ts";

/**
 * Écran encore à construire. Il porte le même cadre (coquille, charte) que les écrans finis :
 * la fondation est là, le contenu suit. La référence renvoie au brief d'écrans.
 */
export function EnCours(): React.ReactElement {
  const { chemin } = useRoute();
  const meta = metaPour(chemin);
  return (
    <div className="card" style={{ maxWidth: 560, padding: "28px 26px", display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span className="pill pill-accent">{meta.ref}</span>
        <span className="pill pill-warn">En construction</span>
      </div>
      <h2 className="display" style={{ fontSize: 22, margin: 0 }}>{meta.label}</h2>
      <p style={{ margin: 0, color: "var(--muted)", lineHeight: 1.55 }}>
        Cet écran fait partie de la maquette et sera construit dans un prochain incrément.
        La coquille, la charte de l'édition et le système de design sont déjà en place —
        il ne reste que le contenu de cette page.
      </p>
      <div style={{ display: "grid", gap: 8 }}>
        {[70, 100, 85].map((w, i) => (
          <div key={i} style={{ height: 12, width: `${w}%`, borderRadius: 6, background: "var(--panel)" }} />
        ))}
      </div>
    </div>
  );
}
